
import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef, MatTableDataSource, MatPaginator, MatCheckboxChange } from '@angular/material';
import { DxService } from 'src/app/Services/NewVisitNote/dx.service';
import { IDxCategory, IDxIcdCodes, IDXDetails, IDxComponent } from 'src/app/models/IDXDetails';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
//import { DxCategoryComponent } from './dx-category/dx-category.component';
import { moveItemInArray } from '@angular/cdk/drag-drop';
//import { ConfirmDialogModel, DeleteDocumentComponent } from '../../Document/delete-document/delete-document.component';
import { BehaviorSubject } from 'rxjs';
//import { CopyFromPreviousNotesComponent } from '../copy-from-previous-notes/copy-from-previous-notes.component';
import { ConfirmationDialogComponent } from 'src/app/ChildControls/confirmation-dialog/confirmation-dialog.component';
import { CopyEncounterData } from 'src/app/models/copyEncounterData';
import { ProgressNotesService } from 'src/app/Services/NewVisitNote/progress-notes.service';
import { element } from 'protractor';
import { IEncounterData } from 'src/app/models/IEncounterData';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { LockService } from 'src/app/Services/LockService/lock-service.service';
import { Defaults } from 'src/app/Utilities/defaults';
import { NgxSpinnerService } from 'ngx-spinner';
import { Diagnosis } from 'src/app/models/IORRecord';


export interface AllActive {
  value: string;
  isActive: number;
}
// export interface DialogData {
//   icdlist: Diagnosis[];
// }

@Component({
  selector: 'app-ordiagnosis',
  templateUrl: './ordiagnosis.component.html',
  styleUrls: ['./ordiagnosis.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})

export class ORDiagnosisComponent implements OnInit {
  displayedColumnsd: string[] = ['icdcode', 'icddescription', 'Action'];

  Displayactives: AllActive[] = [
    { isActive: 0, value: 'All' },
    { isActive: 1, value: 'Active' },
    { isActive: 2, value: 'Inactive' }
  ];

  ORDXForm: FormGroup;
  activetab = 10;
  dxInfo: IDXDetails;
  dxComponent: IDXDetails[] = [];
  selecteddxComponentData: IDXDetails;
  addDxComponent: IDxComponent;
  lstdxComponent: IDXDetails[] = [];
  lstDxAllProblems: IDXDetails[] = [];
  public IsAllCatDiv: boolean = false;
  disabledSaveSignoffButton: boolean = false;
  public IsAllProblemsDiv: boolean = true;
  SignOffClicked: boolean = false;
  public selected = this.Displayactives[0].isActive;
  public encounterId: string;
  public signoffEnc: IEncounterData;
  saveflag: boolean = false;
  //selectedRowIndex: number = -1;
  oncategoryIndex: number = 2;
  isactiveval: number = 1;
  dxCategorydata: IDxCategory[] = [];
  dxAllIcdCodes: IDxIcdCodes[] = [];
  // dxselectedIcdCodes: IDxIcdCodes[] = [];
  dxselectedIcdCodes: IDXDetails[] = [];
  SelectpastDx: IDXDetails;
  displaydxIcdCodes: IDXDetails[] = [];
  dxPastProblems: IDXDetails[] = [];
  dxPastProblems1: IDXDetails[] = [];
  selectallproblemfromDbByEncId: IDxIcdCodes;
  filterDxAllIcdCodes: IDxIcdCodes[] = [];
  selctedEncIcdCode: IDxIcdCodes;
  dataSource1 = new MatTableDataSource(this.dxAllIcdCodes);
  dataSource2 = new MatTableDataSource(this.dxCategorydata);
  dataSource = new MatTableDataSource(this.dxComponent);
  tempdataSource = new MatTableDataSource(this.dxselectedIcdCodes);
  dataSource5 = new MatTableDataSource(this.dxselectedIcdCodes);
  isTabchange: boolean = false;
  changedTabLabel: string = '';

  public AdddxAllIcdCodes: IDxIcdCodes[] = [];
  public selctedIcdCode: IDXDetails;
  public VisitNoteDx: boolean = false;
  dataSourcesavedDiagnosis: IDXDetails[] = [];
  visitEncIcdCodes: IDXDetails[] = [];
  proceduresComponent: Diagnosis[] = [];
  Currpatprocedures: Diagnosis[] = [];
  public AdddxAllIcdCode: IDXDetails[] = [];
  dataSourceVisitNoteDx = new MatTableDataSource(this.AdddxAllIcdCode);
  checkDxlist: IDXDetails[] = [];
  displayedColumnss1: string[] = ['icdcode', 'icdcodedescription', 'action'];
  headercolumnsToDisplay = ['ICDCODE', 'Description', 'Notes', 'Action'];
  columnsToDisplay = ['icdCode', 'icdCodeDescription', 'notes', 'priority', 'Action'];

  displayedColumnss: string[] = ['icdcode', 'icddescription', 'Actions'];
  // displayedColumnss: string[] = ['icdcode', 'icddescription'];
  displayedColumnses: string[] = ['Category',];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  icd: string = '';
  public selectCategory: number = 2;
  public result: any;
  private _searchTerm: string;
  headerVisibility: boolean;
  controls: FormArray;
  white: string = 'opacity: 0.0';
  blue: string = '#BAFBC1';
  lockedUser: any;
  lockMessage: any;
  callSave = false;
  public noteBeforeChange: string = "";
  searchResults: string = '';
  constructor(private fb: FormBuilder
    , private router: Router
    , private route: ActivatedRoute
    , private dxService: DxService
    , private toastr: ToastrService
    , public dialog: MatDialog
    , public progressService: ProgressNotesService
    , private sharedservice: SharedService
    , private spinner: NgxSpinnerService
    , private lockService: LockService
    , public dialogRef: MatDialogRef<ORDiagnosisComponent>,
  ) {
    this.getSystem();
    this.encounterId = CommonComponents.encounterId;
    this.getVisitIsSignedoff();
    this.headerVisibility = CommonComponents.headerVisibility;
    //this.deleteLockUser();

  }
  getSystem() {

    if (sessionStorage.getItem("encounterid") != null || sessionStorage.getItem("encounterid") != undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {

    this.ORDXForm = this.fb.group(
      {
        searchTerm: [''],
        priority: [''],
        notes: [''],
        dataSource: [],
        dataSource1: [],
        dataSource2: [],
        visitNoteDx: [''],
        // DxTable: this.fb.array([]),
      });
    this.loadDxFormCategorydata();
    this.loadDxFormIcddata();
    // this.setEncDXTable();


    if (CommonComponents.encounterId && CommonComponents.patientId) {
      //this.getDXInfo(CommonComponents.encounterId, CommonComponents.patientId);
      // this.getAllProblemsInfoById(CommonComponents.encounterId, CommonComponents.patientId);
      //this.getAllCurrentProblemsInfoById(CommonComponents.encounterId, CommonComponents.patientId);

    }
    else {
      this.dxInfo = {
        dxId: null,
        patientId: null,
        EncounterId: '',
        icdCode: '',
        icdCodeDescription: '',
        notes: '',
        isActive: null,
        priority: null,
        createdBy: '',
        createdOn: null,
        modifiedBy: '',

        modifiedOn: null,
        background: '',
        isPast: null,
        categoryId: null,
        status: '',
        startDate: '',
        endDate: '',
        type: '',
      };
    }

    // this.DXForm.get('searchTerm').valueChanges.subscribe(
    //   value => {
    //     this.dataSource1.data = this.onIcdCodeSearcClick(value);
    //   });

    this.checkStatus = true;

    this.ORDXForm.get('searchTerm').valueChanges.subscribe(
      value => {
        if (this.selectCategory == 2) {
          this.dataSource5.data = this.onProblemsIcdCodeSearchClick(value);
          if (value != "") {

            if (this.dataSource5.data.length == 0) {
              this.searchResults = "No search results found."
            } else {
              this.searchResults = "";
            }
          }

        }
        else {

          if (this.ORDXForm.value.visitNoteDx == true) {
            if (value != "") {
              this.dataSourceVisitNoteDx.data = this.onCurrentVisitNoteDx(value)
              if (this.dataSourceVisitNoteDx.data.length == 0) {
                this.searchResults = "No search results found."
              } else {
                this.searchResults = "";
              }
            } else {
              this.searchResults = "";
              this.dataSourceVisitNoteDx.data = this.AdddxAllIcdCode;
              this.dataSourceVisitNoteDx.paginator = this.paginator;
            }
          } else {

            this.dataSource1.data = this.onIcdCodeSearcClick(value);

            if (value != "") {
              if (this.dataSource1.data.length == 0) {
                this.searchResults = "No search results found."
              } else {
                this.searchResults = "";
              }
            }
          }
        }
      });

    // if (this.ORDXForm.value.visitNoteDx == true) {
    //   this.ORDXForm.get('searchTerm').valueChanges.subscribe(
    //     value => {
    //        

    //       this.dataSourceVisitNoteDx.data = this.onCurrentVisitNoteDx(value)
    //       if (value != "") {
    //         if (this.dataSourceVisitNoteDx.data.length == 0) {
    //           this.searchResults = "No search results found."
    //         } else {
    //           this.searchResults = "";
    //         }
    //       }
    //     });
    // }
    this.callSave = false;


  }

  getDXInfo(encId: string, patId: number) {
    this.dxService.getDxIcdByEncId(encId, patId)
      .subscribe(
        (encDxInfo: IDXDetails[]) => {
          this.dxComponent = encDxInfo;
          this.dxAllIcdCodes.forEach(element => { element.background = this.white });
          this.dxCategorydata.forEach(x => { x.background = this.white });
          //var allProcList = this.dxAllIcdCodes.filter(x => x.background === this.blue);
          this.dxComponent.forEach(element => {
            const icdindex = this.dxAllIcdCodes.findIndex(x => x.icdCode === element.icdCode);
            this.dxAllIcdCodes[icdindex].background = this.blue;
            var cat = this.dxAllIcdCodes.filter(x => x.icdCode === element.icdCode);
            const categoryIndex = this.dxCategorydata.findIndex(x => x.categoryId === cat[0].categoryId);
            this.dxCategorydata[categoryIndex].background = this.blue;
          });
          if (this.dxComponent.length === 0) {
            this.dxCategorydata[0].background = this.white;
          } else {
            this.dxCategorydata[0].background = this.blue;
          }

          this.dataSource.data = this.dxComponent;
          this.getAllCurrentProblemsInfoById(CommonComponents.encounterId, CommonComponents.patientId);
        },
        (err: any) => {
          console.log(err);
          this.spinner.hide();
        });
  }

  getAllProblemsInfoById(encId: string, patId: number) {
    this.dxPastProblems = [];
    this.dxService.getDxAllProblemsByEncId(encId, patId)
      .subscribe(
        (encDxAllProblemsInfo: IDXDetails[]) => {
          if (encDxAllProblemsInfo.length > 0) {
            encDxAllProblemsInfo.forEach(element => {
              if (element.icdCode != null) {
                this.selecteddxComponentData = {
                  dxId: 0,
                  patientId: CommonComponents.patientId,
                  EncounterId: CommonComponents.encounterId,
                  icdCode: element.icdCode,
                  icdCodeDescription: element.icdCodeDescription,
                  notes: element.notes,
                  isActive: element.isActive,
                  priority: element.priority,
                  createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
                  createdOn: null,
                  modifiedBy: '',
                  modifiedOn: null,
                  background: '',
                  isPast: true,
                  categoryId: element.categoryId,
                  status: '',
                  startDate: '',
                  endDate: '',
                  type: (element.type != '' && element.type) ? element.type : ''
                }

                if (this.selecteddxComponentData != null) {

                  const removeindex = this.dxPastProblems.findIndex(x => x.icdCode === this.selecteddxComponentData.icdCode);
                  if (removeindex != -1)
                    this.dxPastProblems.splice(removeindex, 1);

                  this.dxPastProblems.push(this.selecteddxComponentData);
                  this.selecteddxComponentData = null;
                }
              }
            });
          }
          this.dxselectedIcdCodes = this.dxPastProblems;
          this.dataSource5.data = this.dxselectedIcdCodes;
          this.dataSource5.paginator = this.paginator;
          this.saveflag = true;
          this.selected = this.Displayactives[0].isActive;
          if (this.isTabchange == true) {
            this.isTabchange = false;
            this.router.navigateByUrl('/' + this.changedTabLabel.replace(" ", ""));
          }
          this.spinner.hide();
        }
        , (err: any) => {
          console.log(err);
          this.spinner.hide();
        });
  }


  getAllCurrentProblemsInfoById(encId: string, patId: number) {
    this.dxService.getDxAllCurrentProblemsByEncId(encId)
      .subscribe(
        (encDxCurrAllProblemsInfo: IDXDetails[]) => {

          if (encDxCurrAllProblemsInfo.length > 0) {
            this.dxselectedIcdCodes = encDxCurrAllProblemsInfo;
            var allProcList = this.dxAllIcdCodes.filter(x => x.background === this.blue);
            if (this.dxComponent.length !== 0) {
              let i: number = 0;
              this.dxComponent.forEach(element => {
                const icdindex = this.dxselectedIcdCodes.findIndex(x => x.icdCode === element.icdCode);
                this.dxselectedIcdCodes[icdindex].background = this.blue;
                var cat = this.dxAllIcdCodes.filter(x => x.icdCode === element.icdCode);
                if (cat !== null) {
                  const categoryIndex = this.dxCategorydata.findIndex(x => x.categoryId === cat[0].categoryId);
                  this.dxCategorydata[categoryIndex].background = this.blue;
                }
              });
            }
            var bgList = this.dxselectedIcdCodes.filter(x => x.background === this.blue);
            if (bgList.length === 0) {
              this.dxCategorydata[1].background = this.white;
            } else {
              this.dxCategorydata[1].background = this.blue;
            }
            this.dataSource5.data = this.dxselectedIcdCodes;
            this.dataSource5.paginator = this.paginator;
            this.saveflag = true;
            this.selected = this.Displayactives[0].isActive;

            if (this.isTabchange == true) {
              this.isTabchange = false;
              this.router.navigateByUrl('/' + this.changedTabLabel.replace(" ", ""));
            }
            this.spinner.hide();
          }
          else {
            this.getAllProblemsInfoById(encId, patId);
          }
          //this.getDXInfo(CommonComponents.encounterId, CommonComponents.patientId);
        },
        (err: any) => {
          console.log(err);
          this.spinner.hide();
        });
  }



  loadDxFormCategorydata() {

    this.dxService.getDxCategory().subscribe((data) => {

      this.dxCategorydata = data;
      this.dataSource2.data = this.dxCategorydata;

    });

  }

  loadDxFormIcddata() {

    this.dxService.getDxIcdCodes().subscribe((data) => {

      this.dxAllIcdCodes = data;
      this.dataSource1.data = this.dxAllIcdCodes;
      this.dataSource1.paginator = this.paginator;
      if (CommonComponents.encounterId && CommonComponents.patientId) {
        this.getDXInfo(CommonComponents.encounterId, CommonComponents.patientId);

        // this.getAllProblemsInfoById(CommonComponents.encounterId, CommonComponents.patientId);
        //this.getAllCurrentProblemsInfoById(CommonComponents.encounterId, CommonComponents.patientId);

      }

    });

  }
  public ischkUnchk: boolean = false;
  oncategoryClick(catgeoryId: number) {

    $(".rgt-scrl").scrollTop(0);
    $(".scrls").scrollTop(0);
    this.searchResults = '';

    // alert("category clicked" + catgeoryId);
    this.ORDXForm.patchValue({
      visitNoteDx: '',
      searchTerm: ''
    })
    this.selectCategory = catgeoryId;
    this.VisitNoteDx = false;
    //   this.ischkUnchk = false;

    if (catgeoryId == 1) {
      this.IsAllCatDiv = true;
      this.IsAllProblemsDiv = false;
      this.dataSource1.data = this.dxAllIcdCodes;
      this.dataSource1.paginator = this.paginator;
    }
    else if (catgeoryId == 2) {
      this.IsAllCatDiv = false;
      this.IsAllProblemsDiv = true;
      // if(this.ischkUnchk==true)
      // this.ischkUnchk=false;
      // this.dataSource5.data = this.dxselectedIcdCodes.filter((attr: IDXDetails) => attr.isActive == true);
      //this.selected = this.Displayactives[0].isActive;
      //this.dataSource5.data = this.dxselectedIcdCodes;
      this.selected = this.Displayactives[1].isActive;
      this.dxPastProblems1 = this.dxselectedIcdCodes;
      let tempdata = [];
      let tempdata1 = [];
      tempdata = JSON.parse(JSON.stringify(this.dxPastProblems1));
      for (var i = 0; i < tempdata.length; i++) {
        if (tempdata[i].isActive === true) {
          tempdata1.push(tempdata[i]);
        }
      }

      this.dataSource5.data = tempdata1;
      this.dataSource5.paginator = this.paginator;
    }
    else {
      this.IsAllCatDiv = true;
      this.IsAllProblemsDiv = false;
      this.dataSource1.data = this.dxAllIcdCodes.filter((attr: IDxIcdCodes) => attr.categoryId == catgeoryId);
      this.dataSource1.paginator = this.paginator;
    }
    if (!this.VisitNoteDx) {
      // if (catgeoryId == 2) {
      //   this.Iscurrenticdclicked = false;
      // }
      // else {
      this.Iscurrenticdclicked = true;
      //}
    }
    else {
      this.Iscurrenticdclicked = false;
    }
  }

  // onIcdCodeClick(index: number, element: IDxIcdCodes) {
  //   this.callSave = true;
  //   //  alert("category clicked" + categoryCodeId); 
  //   let icdcode = element.icdCode;

  //   // const categoryIndex = this.dxCategorydata.findIndex(x => x.categoryId === element.categoryId);
  //   // if (categoryIndex !== -1) {
  //   //   this.dxCategorydata[categoryIndex].background = this.blue;
  //   // }

  //   // var cat = this.dxAllIcdCodes.filter(x => x.icdCode === element.icdCode);
  //   // if (cat !== null) {
  //   //   const categoryIndex = this.dxCategorydata.findIndex(x => x.categoryId === cat[0].categoryId);
  //   //   this.dxCategorydata[categoryIndex].background = this.blue;
  //   // }

  //   // const icdindex = this.dxAllIcdCodes.findIndex(x => x.icdCode === element.icdCode);
  //   // this.dxAllIcdCodes[icdindex].background = this.blue;

  //   // var elemt = this.dxAllIcdCodes.filter((attr: IDxIcdCodes) => attr.icdCode === icdcode);
  //   // this.selctedEncIcdCode = elemt[0];

  //   // this.selecteddxComponentData = {
  //   //   dxId: 0,
  //   //   patientId: CommonComponents.patientId,
  //   //   EncounterId: CommonComponents.encounterId,
  //   //   icdCode: this.selctedEncIcdCode.icdCode,
  //   //   icdCodeDescription: this.selctedEncIcdCode.icdCodeDescription,
  //   //   notes: '',
  //   //   isActive: true,
  //   //   priority: this.dxComponent.length + 1,
  //   //   createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
  //   //   createdOn: null,
  //   //   modifiedBy: '',
  //   //   modifiedOn: null,
  //   //   background: this.blue,
  //   //   isPast: null
  //   // }

  //   // if (this.selecteddxComponentData != null) {
  //   //   const removeindex = this.dxselectedIcdCodes.findIndex(x => x.icdCode === this.selecteddxComponentData.icdCode);
  //   //   if (removeindex == -1)
  //   //     // this.dxselectedIcdCodes.splice(0, 0, this.selecteddxComponentData);
  //   //     this.dxselectedIcdCodes.push(this.selecteddxComponentData);


  //   //   if (this.selecteddxComponentData != null) {
  //   //     const removeindex1 = this.dxComponent.findIndex(x => x.icdCode === this.selecteddxComponentData.icdCode);
  //   //     const removeindex = this.dxselectedIcdCodes.findIndex(x => x.icdCode === icdcode);
  //   //     this.dxselectedIcdCodes[removeindex].background = this.blue;
  //   //     if (removeindex1 == -1)
  //   //       // this.dxComponent.splice(0, 0, this.selecteddxComponentData);
  //   //       this.dxComponent.push(this.selecteddxComponentData);
  //   //   }

  //   //   this.selecteddxComponentData = null
  //   //   this.selctedEncIcdCode = null;

  //   // }

  //   // var bgList = this.dxselectedIcdCodes.filter(x => x.background === this.blue);
  //   // if (bgList.length === 0) {
  //   //   this.dxCategorydata[1].background = this.white;
  //   // } else {
  //   //   this.dxCategorydata[1].background = this.blue;
  //   // }

  //   // var catList = this.dxAllIcdCodes.filter(x => x.background === this.blue);
  //   // if (catList.length === 0) {
  //   //   this.dxCategorydata[0].background = this.white;
  //   // } else {
  //   //   this.dxCategorydata[0].background = this.blue;
  //   // }

  //   // this.dataSource.data = this.dxComponent;
  //   // //this.dataSource5.data = this.dxselectedIcdCodes;
  //   // this.dxPastProblems1 = this.dxselectedIcdCodes;
  //   // let tempdata2 = [];
  //   // let tempdata3 = [];
  //   // tempdata2 = JSON.parse(JSON.stringify(this.dxPastProblems1));
  //   // if (this.isactiveval === 0) {
  //   //   for (var i = 0; i < tempdata2.length; i++) {
  //   //     if (tempdata2[i].isActive === true || tempdata2[i].isActive === false) {
  //   //       tempdata3.push(tempdata2[i]);
  //   //     }
  //   //   }
  //   // }
  //   // if (this.dataSource.data.length != 0) {
  //   //   if (this.isactiveval === 1 && this.dataSource.data[this.dataSource.data.length - 1].isActive === true) {
  //   //     for (var d = 0; d < tempdata2.length; d++) {
  //   //       if (tempdata2[d].isActive === true) {
  //   //         tempdata3.push(tempdata2[d]);
  //   //       }
  //   //     }
  //   //   }
  //   //   //&& this.dataSource.data[this.dataSource.data.length - 1].isActive === false)
  //   //   if (this.isactiveval === 2) {
  //   //     for (var e = 0; e < tempdata2.length; e++) {
  //   //       if (tempdata2[e].isActive === false) {
  //   //         tempdata3.push(tempdata2[e]);
  //   //       }
  //   //     }
  //   //   }
  //   // }


  //   // this.dataSource5.data = tempdata3;
  //   // this.dataSource5.paginator = this.paginator;

  // }



  onIcdCodeClick(icds: IDxIcdCodes) {

    // var elemt = this.AdddxAllIcdCodes.filter((attr: IDXDetails) => attr.icdCode === icds.icdCode);
    // this.selctedIcdCode = elemt[0];
    // this.AdddxAllIcdCodes.push(icds);
    // this.dialogRef.close(this.AdddxAllIcdCodes);
    if (this.checkDxlist.length === 0) {
      this.toastr.error('No Dx is selected.')
      return false;
    } else {
      this.dialogRef.close(this.checkDxlist);

    }

  }//
  Iscurrenticdclicked: boolean = true;
  bgcolor: string = '';
  currentVisitencDxCurrAllProblemsInfo: IDXDetails[] = [];
  checkStatus: boolean = false;
  AddCurrentVisitNoteDx(event, element: IDXDetails) {

    // this.ischkUnchk = event.checked;
    // this.ischkUnchk = !this.ischkUnchkVisitProc;
    this.searchResults = "";
    this.ORDXForm.patchValue({
      searchTerm: ''
    })
    if (event.checked) {
      this.VisitNoteDx = true;
      this.IsAllProblemsDiv = false;
      this.Iscurrenticdclicked = false;
      this.IsAllCatDiv = false;
      this.dxService.getDxIcdByEncId(CommonComponents.encounterId, CommonComponents.patientId)
        .subscribe(

          (encDxCurrAllProblemsInfo: IDXDetails[]) => {

            this.currentVisitencDxCurrAllProblemsInfo = encDxCurrAllProblemsInfo;

            if (encDxCurrAllProblemsInfo.length > 0) {
              this.AdddxAllIcdCode = encDxCurrAllProblemsInfo;
              this.ischeckedunchecked();
              this.dataSourceVisitNoteDx.data = this.AdddxAllIcdCode;
              this.dataSourceVisitNoteDx.paginator = this.paginator;
            }
            if (this.checkStatus == false) {
              if (this.ORDXForm.value.visitNoteDx == true) {
                this.ORDXForm.get('searchTerm').valueChanges.subscribe(
                  value => {


                    this.dataSourceVisitNoteDx.data = this.onCurrentVisitNoteDx(value)
                    if (value != "") {
                      if (this.dataSourceVisitNoteDx.data.length == 0) {
                        this.searchResults = "No search results found."
                      } else {
                        this.searchResults = "";
                      }
                    }
                  });
              }
            }

            this.callSave = false;

            // else {
            // }
          },
          (err: any) => console.log(err)
        );

    } else {
      this.searchResults = "";
      this.Iscurrenticdclicked = true;
      this.VisitNoteDx = false;
      if (this.selectCategory == 1 || this.oncategoryIndex == 1) {
        if (this.selectCategory == 0) {
          this.oncategoryIndex == 1
        } else {
          this.oncategoryIndex = this.selectCategory;
        }
        this.IsAllCatDiv = true;
        this.IsAllProblemsDiv = false;
        this.dataSource1.data = this.dxAllIcdCodes;
        this.dataSource1.paginator = this.paginator;
      }
      else if (this.selectCategory == 2) {
        this.oncategoryIndex = this.selectCategory;
        this.IsAllCatDiv = false;
        this.IsAllProblemsDiv = true;
        this.selected = this.Displayactives[1].isActive;
        this.dxPastProblems1 = this.dxselectedIcdCodes;
        let tempdata = [];
        let tempdata1 = [];
        tempdata = JSON.parse(JSON.stringify(this.dxPastProblems1));
        for (var i = 0; i < tempdata.length; i++) {
          if (tempdata[i].isActive === true) {
            tempdata1.push(tempdata[i]);
          }
        }

        this.dataSource5.data = tempdata1;
        this.dataSource5.paginator = this.paginator;
      }
      else {
        this.oncategoryIndex = this.selectCategory;
        this.IsAllCatDiv = true;
        this.IsAllProblemsDiv = false;
        this.dataSource1.data = this.dxAllIcdCodes.filter((attr: IDxIcdCodes) => attr.categoryId == this.selectCategory);
        this.dataSource1.paginator = this.paginator;
      }
    }

  }
  ischeckedunchecked() {
    if (this.AdddxAllIcdCode.length > 0) {
      for (var i = 0; i < this.AdddxAllIcdCode.length; i++) {
        if (this.AdddxAllIcdCode[i].icdCode) {
          this.bgcolor = this.blue;
        }
        else {
          this.bgcolor = this.white;
        }
      }
    }
  }
  AddcurrentVisitNoteCancel() {
    this.dialogRef.close();
  }
  //selectedele: IDXDetails;
  public selectedele: IDXDetails[] = [];
  selectedVisitNoteDx(index: number, ele: IDXDetails) {
    // this.selectedele = ele;
    this.selectedele.push(ele);
  }

  AddcurrentVisitNoteDxRecord() {
    this.dialogRef.close(this.selectedele);
  }

  checkVisitNoteDx(event: MatCheckboxChange, ele: IDXDetails): void {
    //alert(event.checked)

    if (event.checked) {
      this.disableAddCurrntVisit = false;
      this.checkDxlist.push(ele)
    } else {
      this.checkDxlist = this.checkDxlist.filter(a => a !== ele);
    }
  }
  disableAddCurrntVisit: boolean = true;
  AddcurrentVisitNoteDxOrRecord() {
    if (this.checkDxlist.length > 0) {
      this.dialogRef.close(this.checkDxlist);
    } else {
      alert('select atleast one dx.')
    }
  }
  // AddCurrentAllProblems() {
  //   // alert("All current problems adding in progress");


  //   if (this.dxselectedIcdCodes.length > 0) {

  //     this.dxselectedIcdCodes.forEach(element => {

  //       let icdcode = element.icdCode;

  //       // const categoryIndex = this.dxCategorydata.findIndex(x => x.categoryId === element.categoryId);
  //       // if (categoryIndex !== -1) {
  //       //   this.dxCategorydata[categoryIndex].background = this.blue;
  //       // }

  //       var cat = this.dxAllIcdCodes.filter(x => x.icdCode === element.icdCode);
  //       if (cat !== null) {
  //         const categoryIndex = this.dxCategorydata.findIndex(x => x.categoryId === cat[0].categoryId);
  //         this.dxCategorydata[categoryIndex].background = this.blue;
  //       }

  //       const icdindex = this.dxAllIcdCodes.findIndex(x => x.icdCode === element.icdCode);
  //       this.dxAllIcdCodes[icdindex].background = this.blue;

  //       var elemt = this.dxAllIcdCodes.filter((attr: IDxIcdCodes) => attr.icdCode === icdcode);
  //       this.selctedEncIcdCode = elemt[0];

  //       this.selecteddxComponentData = {
  //         dxId: 0,
  //         patientId: CommonComponents.patientId,
  //         EncounterId: CommonComponents.encounterId,
  //         icdCode: this.selctedEncIcdCode.icdCode,
  //         icdCodeDescription: this.selctedEncIcdCode.icdCodeDescription,
  //         notes: '',
  //         isActive: true,
  //         priority: this.dxComponent.length + 1,
  //         createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
  //         createdOn: null,
  //         modifiedBy: '',
  //         modifiedOn: null,
  //         background: this.blue,
  //         isPast: null
  //       }

  //       if (this.selecteddxComponentData != null) {
  //         const removeindex = this.dxselectedIcdCodes.findIndex(x => x.icdCode === this.selecteddxComponentData.icdCode);
  //         if (removeindex == -1)
  //           // this.dxselectedIcdCodes.splice(0, 0, this.selecteddxComponentData);
  //           this.dxselectedIcdCodes.push(this.selecteddxComponentData);


  //         if (this.selecteddxComponentData != null) {
  //           const removeindex1 = this.dxComponent.findIndex(x => x.icdCode === this.selecteddxComponentData.icdCode);
  //           const removeindex = this.dxselectedIcdCodes.findIndex(x => x.icdCode === icdcode);
  //           this.dxselectedIcdCodes[removeindex].background = this.blue;
  //           if (removeindex1 == -1)
  //             // this.dxComponent.splice(0, 0, this.selecteddxComponentData);
  //             this.dxComponent.push(this.selecteddxComponentData);
  //         }

  //         this.selecteddxComponentData = null
  //         this.selctedEncIcdCode = null;

  //       }

  //       var bgList = this.dxselectedIcdCodes.filter(x => x.background === this.blue);
  //       if (bgList.length === 0) {
  //         this.dxCategorydata[1].background = this.white;
  //       } else {
  //         this.dxCategorydata[1].background = this.blue;
  //       }

  //       var catList = this.dxAllIcdCodes.filter(x => x.background === this.blue);
  //       if (catList.length === 0) {
  //         this.dxCategorydata[0].background = this.white;
  //       } else {
  //         this.dxCategorydata[0].background = this.blue;
  //       }

  //       this.dataSource.data = this.dxComponent;

  //       this.dataSource5.data = this.dxselectedIcdCodes;
  //       this.dataSource5.paginator = this.paginator;

  //     });
  //     this.callSave = true;
  //   }
  //   //this.callSave = true;

  // }
  AddCurrentAllProblems() {
    if (this.dxselectedIcdCodes.length > 0) {
      this.dialogRef.close(this.dxselectedIcdCodes);
    }
    else {
      this.dialogRef.close();
    }
  }
  AddVisitNoteAllDiagnosis() {
    if (this.AdddxAllIcdCode.length > 0) {
      this.dialogRef.close(this.AdddxAllIcdCode);
    }
    else {
      this.dialogRef.close();
    }
  }
  // onIcdCodeDeleteClick(categoryCodeId: number) {
  //   // alert("category clicked" + categoryCodeId);   

  //   const message = "Are you sure to delete ICD Code from selected Category? ";
  //   const dialogData = new ConfirmDialogModel('Confirm Action', message);
  //   const dialogRef = this.dialog.open(DeleteDocumentComponent, {
  //     maxWidth: '400px',
  //     height: '120px',
  //     data: dialogData
  //   });

  //   dialogRef.afterClosed().subscribe(dialogResult => {
  //     this.result = dialogResult;
  //     if (this.result) {
  //       this.dxService.UpdateIcdCategoryInfo(categoryCodeId).subscribe(
  //         results => {
  //           this.result = results;
  //           this.loadDxFormIcddata();
  //           this.toastr.success(this.result);
  //         }
  //       );

  //     } else {
  //       this.result = dialogResult;
  //     }
  //   });

  // }

  // onSelectIcdCodeDeleteClick(element: IDXDetails) {

  //   const message = "Are you sure to delete ICD Code from selected VisitNote? ";
  //   const dialogData = new ConfirmDialogModel('Confirm Action', message);
  //   const dialogRef = this.dialog.open(DeleteDocumentComponent, {
  //     maxWidth: '400px',
  //     height: '120px',
  //     data: dialogData
  //   });

  //   dialogRef.afterClosed().subscribe(dialogResult => {
  //     this.result = dialogResult;
  //     if (this.result) {
  //       var delid = element.dxId;
  //       var delIcd = element.icdCode;

  //       const icdindex = this.dxAllIcdCodes.findIndex(x => x.icdCode === element.icdCode);
  //       this.dxAllIcdCodes[icdindex].background = this.white;
  //       var cat = this.dxAllIcdCodes.filter(x => x.icdCode === element.icdCode);
  //       if (cat !== null) {
  //         var catlist = this.dxAllIcdCodes.filter(x => x.categoryId === cat[0].categoryId);
  //         var bgList = catlist.filter(x => x.background === this.blue);
  //         const categoryIndex = this.dxCategorydata.findIndex(x => x.categoryId === cat[0].categoryId);
  //         if (bgList.length === 0) {
  //           this.dxCategorydata[categoryIndex].background = this.white;
  //         } else {
  //           this.dxCategorydata[categoryIndex].background = this.blue;
  //         }
  //       }

  //       // if (delid == 0) {
  //       //   const removeindex3 = this.dxselectedIcdCodes.findIndex(x => x.icdCode === delIcd);
  //       //   if (removeindex3 != -1)
  //       //     this.dxselectedIcdCodes.splice(removeindex3, 1);
  //       // }
  //       if (delid == 0) {
  //         //Current Encounter
  //         const removeindex2 = this.dxComponent.findIndex(x => x.icdCode === delIcd);
  //         const allpatindex = this.dxselectedIcdCodes.findIndex(x => x.icdCode === delIcd);
  //         this.dxselectedIcdCodes[allpatindex].background = this.white;
  //         if (removeindex2 != -1)
  //           this.dxComponent.splice(removeindex2, 1);

  //         //Past Encounter
  //         var pastDx = this.dxselectedIcdCodes.filter(x => x.icdCode === delIcd);
  //         this.SelectpastDx = pastDx[0];
  //         if (this.SelectpastDx.dxId == 0) {
  //           const removeindex3 = this.dxselectedIcdCodes.findIndex(x => x.icdCode === delIcd && x.isPast != true);
  //           if (removeindex3 != -1)
  //             this.dxselectedIcdCodes.splice(removeindex3, 1);
  //         }
  //       }

  //       if (delid > 0) {

  //         const removeindex4 = this.dxComponent.findIndex(x => x.dxId === delid);
  //         const allpatindex = this.dxselectedIcdCodes.findIndex(x => x.icdCode === delIcd);
  //         this.dxselectedIcdCodes[allpatindex].background = this.white;
  //         if (removeindex4 != -1)
  //           this.dxComponent.splice(removeindex4, 1);

  //         //Past Encounter
  //         var pastDx = this.dxselectedIcdCodes.filter(x => x.icdCode === delIcd);
  //         this.SelectpastDx = pastDx[0];
  //         if (this.SelectpastDx.dxId > 0) {
  //           const removeindex3 = this.dxselectedIcdCodes.findIndex(x => x.icdCode === delIcd && x.isPast != true);
  //           if (removeindex3 != -1)
  //             this.dxselectedIcdCodes.splice(removeindex3, 1);
  //         }
  //         this.dxService.DeleteSelectIcdCodeInfo(delid).subscribe(
  //           results => {
  //             this.result = results;
  //             // if (CommonComponents.encounterId && CommonComponents.patientId) {
  //             //   this.getAllCurrentProblemsInfoById(CommonComponents.encounterId, CommonComponents.patientId);
  //             //   this.getDXInfo(CommonComponents.encounterId, CommonComponents.patientId);
  //             // }
  //             this.dataSource.data = this.dxComponent;
  //             //this.dataSource5.data = this.dxselectedIcdCodes;
  //             this.dxPastProblems1 = this.dxselectedIcdCodes;
  //             let tempdata5 = [];
  //             let tempdata6 = [];
  //             tempdata5 = JSON.parse(JSON.stringify(this.dxPastProblems1));
  //             if (this.isactiveval === 0) {
  //               for (var h = 0; h < tempdata5.length; h++) {
  //                 if (tempdata5[h].isActive === true || tempdata5[h].isActive === false) {
  //                   tempdata6.push(tempdata5[h]);
  //                 }
  //               }
  //             }

  //               if (this.isactiveval === 1 ) {
  //                 for (var k = 0; k < tempdata5.length; k++) {
  //                   if (tempdata5[k].isActive === true) {
  //                     tempdata6.push(tempdata5[k]);
  //                   }
  //                 }
  //               }

  //             if (this.isactiveval === 2) {
  //               for (var l = 0; l < tempdata5.length; l++) {
  //                 if (tempdata5[l].isActive === false) {
  //                   tempdata6.push(tempdata5[l]);
  //                 }
  //               }
  //             }

  //             this.dataSource5.data = tempdata6;
  //             this.dataSource5.paginator = this.paginator;
  //             this.toastr.success(this.result);
  //           }
  //         );
  //       } else {
  //         this.dataSource.data = this.dxComponent;
  //        // this.dataSource5.data = this.dxselectedIcdCodes;
  //        this.dxPastProblems1 = this.dxselectedIcdCodes;
  //        let tempdata7 = [];
  //        let tempdata8 = [];
  //        tempdata7 = JSON.parse(JSON.stringify(this.dxPastProblems1));
  //        if (this.isactiveval === 0) {
  //          for (var m = 0; m < tempdata7.length; m++) {
  //            if (tempdata7[m].isActive === true || tempdata7[m].isActive === false) {
  //              tempdata8.push(tempdata7[m]);
  //            }
  //          }
  //        }

  //          if (this.isactiveval === 1 ) {
  //            for (var n = 0; n < tempdata7.length; n++) {
  //              if (tempdata7[n].isActive === true) {
  //                tempdata8.push(tempdata7[n]);
  //              }
  //            }
  //          }

  //        if (this.isactiveval === 2) {
  //          for (var p = 0; p < tempdata7.length; p++) {
  //            if (tempdata7[p].isActive === false) {
  //              tempdata8.push(tempdata7[p]);
  //            }
  //          }
  //        }

  //        this.dataSource5.data = tempdata8;        
  //         this.dataSource5.paginator = this.paginator;
  //         this.toastr.success("DX details delete successfully");
  //       }

  //       var dxseleList = this.dxselectedIcdCodes.filter(x => x.background === this.blue);
  //       if (dxseleList.length === 0) {
  //         this.dxCategorydata[1].background = this.white;
  //       } else {
  //         this.dxCategorydata[1].background = this.blue;
  //       }

  //       var catList = this.dxAllIcdCodes.filter(x => x.background === this.blue);
  //       if (catList.length === 0) {
  //         this.dxCategorydata[0].background = this.white;
  //       } else {
  //         this.dxCategorydata[0].background = this.blue;
  //       }

  //       // this.dataSource.data = this.dxComponent;
  //       // this.dataSource5.data = this.dxselectedIcdCodes;
  //       // this.dataSource5.paginator = this.paginator;

  //     } else {
  //       this.result = dialogResult;
  //     }
  //   });

  // }

  // onSelectAllProblemsIcdCodeDeleteClick(element: IDXDetails) {

  //   const message = "Are you sure to delete ICD Code from Patient all Problems? ";
  //   const dialogData = new ConfirmDialogModel('Confirm Action', message);
  //   const dialogRef = this.dialog.open(DeleteDocumentComponent, {
  //     maxWidth: '400px',
  //     height: '120px',
  //     data: dialogData
  //   });

  //   dialogRef.afterClosed().subscribe(dialogResult => {
  //     this.result = dialogResult;
  //     if (this.result) {
  //       var delid = element.dxId;
  //       var delIcd = element.icdCode;
  //       if (delid == 0) {
  //         const removeindex3 = this.dxselectedIcdCodes.findIndex(x => x.icdCode === delIcd);
  //         if (removeindex3 != -1)
  //           this.dxselectedIcdCodes.splice(removeindex3, 1);
  //       }

  //       // const removeindex2 = this.dxComponent.findIndex(x => x.icdCode === delIcd);
  //       // if (removeindex2 != -1)
  //       //   this.dxComponent.splice(removeindex2, 1);

  //       if (delid > 0) {

  //         const removeindex4 = this.dxselectedIcdCodes.findIndex(x => x.dxId === delid);
  //         if (removeindex4 != -1)
  //           this.dxselectedIcdCodes.splice(removeindex4, 1);
  //         this.dxService.DeleteSelectAllProbIcdCodeInfo(delid).subscribe(
  //           results => {
  //             this.result = results;
  //             this.toastr.success(this.result);
  //           }
  //         );
  //       } else {
  //         this.toastr.success("DX details delete successfully");
  //       }

  //       // this.dataSource.data = this.dxComponent;
  //       this.dataSource5.data = this.dxselectedIcdCodes;
  //       this.dataSource5.paginator = this.paginator;
  //     } else {
  //       this.result = dialogResult;
  //     }
  //   });

  // }


  onIcdCodeSearcClick(searchString: string) {

    if (this.selectCategory > 2) {

      return this.dxAllIcdCodes.filter((attr: IDxIcdCodes) => attr.categoryId == this.selectCategory && (attr.icdCode.toLowerCase().indexOf(searchString.toLowerCase()) !== -1 || attr.icdCodeDescription.toLowerCase().indexOf(searchString.toLowerCase()) !== -1));
    }
    else {
      return this.dxAllIcdCodes.filter((attr: IDxIcdCodes) => attr.icdCode.toLowerCase().indexOf(searchString.toLowerCase()) !== -1 || attr.icdCodeDescription.toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
    }

  }

  onProblemsIcdCodeSearchClick(pbsearchString: string) {
    if (this.selectCategory == 2) {
      return this.dxselectedIcdCodes.filter((attr: IDXDetails) => attr.icdCode.toLowerCase().indexOf(pbsearchString.toLowerCase()) !== -1 || attr.icdCodeDescription.toLowerCase().indexOf(pbsearchString.toLowerCase()) !== -1);
    }
  }
  onProblemsIcdCodeSearchClickVisitNoteDx(pbsearchString: string) {

    return this.dxselectedIcdCodes.filter((attr: IDXDetails) => attr.icdCode.toLowerCase().indexOf(pbsearchString.toLowerCase()) !== -1 || attr.icdCodeDescription.toLowerCase().indexOf(pbsearchString.toLowerCase()) !== -1);

  }
  onCurrentVisitNoteDx(pbsearchString: string) {
    return this.currentVisitencDxCurrAllProblemsInfo.filter((attr: IDXDetails) => attr.icdCode.toLowerCase().indexOf(pbsearchString.toLowerCase()) !== -1 || attr.icdCodeDescription.toLowerCase().indexOf(pbsearchString.toLowerCase()) !== -1);
  }

  statusChange(value, element: IDXDetails) {
    //  alert("category clicked" + value+"  icd"+ icd);

    var delid = element.dxId;

    if (element.dxId != 0) {

      this.dxService.UpdateIcdCodeStatusInfo(CommonComponents.patientId, delid, value, CommonComponents.encounterId, element.icdCode).subscribe(
        results => {
          this.result = results;
          this.getAllCurrentProblemsInfoById(CommonComponents.encounterId, CommonComponents.patientId);
          // this.dataSource.data = this.dxComponent;
          this.dataSource5.data = this.dxselectedIcdCodes;
          this.dataSource5.paginator = this.paginator;
          this.toastr.success(this.result);
        }
      );
    }
    else {
      if (element.icdCode != null) {
        var elemt1 = this.dxselectedIcdCodes.filter((attr: IDXDetails) => attr.icdCode == element.icdCode);
        elemt1[0].isActive = value;
      }
      this.dataSource5.data = this.dxselectedIcdCodes;
      this.dataSource5.paginator = this.paginator;
    }
    this.selected = this.Displayactives[0].isActive;
  }


  DisplaystatusChange(value) {
    this.isactiveval = 0;
    this.isactiveval = value;

    if (this.dxselectedIcdCodes) {
      if (value != null && value == 1) {
        this.displaydxIcdCodes = this.dxselectedIcdCodes.filter((attr: IDXDetails) => attr.isActive == true);
      }
      else if (value != null && value == 2) {
        this.displaydxIcdCodes = this.dxselectedIcdCodes.filter((attr: IDXDetails) => attr.isActive == false);
      }
      else {
        this.displaydxIcdCodes = this.dxselectedIcdCodes
      }
      this.dataSource5.data = this.displaydxIcdCodes;
      this.dataSource5.paginator = this.paginator;
    }

  }


  DxSubmit() {
    // if(this.ORDXForm.touched)
    // {

    if (this.saveflag == true) {
      this.spinner.show();
      this.saveflag = false;
      this.mapFormValuesDXModel();
      this.dxService.addDXInfo(this.addDxComponent).subscribe(
        results => {
          if (results) {
            this.result = results;
            if (CommonComponents.encounterId && CommonComponents.patientId) {
              //this.getAllCurrentProblemsInfoById(CommonComponents.encounterId, CommonComponents.patientId);
              this.getDXInfo(CommonComponents.encounterId, CommonComponents.patientId);
            }
            else {
              this.spinner.hide();
            }
            this.callSave = false;
            this.toastr.success(this.result);
          }
        }
        , (err: any) => {
          console.log(err);
          this.spinner.hide();
        });
    }
    // }
  }

  mapFormValuesDXModel() {

    this.addDxComponent = {
      EncDx: this.dxComponent,
      PatProblems: this.dxselectedIcdCodes
    }
  }

  focusOutNotesFunction(element: IDXDetails) {
    this.callSave = true;
    if (element.icdCode != null) {
      var elemt1 = this.dxComponent.filter((attr: IDXDetails) => attr.icdCode == element.icdCode);
      elemt1[0].notes = this.ORDXForm.value.notes;

    }
    this.dataSource.data = this.dxComponent;
    this.ORDXForm.value.notes = '';
  }

  focusOutPriorityFunction(element: IDXDetails) {
    this.callSave = true;
    if (element.icdCode != null) {
      var elemt1 = this.dxComponent.filter((attr: IDXDetails) => attr.icdCode == element.icdCode);
      elemt1[0].priority = this.ORDXForm.value.priority;
      this.dxComponent = this.dxComponent.sort((a, b) => (a.priority > b.priority) ? 1 : ((b.priority > a.priority) ? -1 : 0));
    }
    this.dataSource.data = this.dxComponent;
    this.ORDXForm.value.priority = '';
  }


  // onCellDeleteClick(element: IDXDetails) {
  //   //  alert("category clicked" + categoryCodeId);  
  //   const message = "Are you sure to delete ICD Code from this encounter? ";
  //   const dialogData = new ConfirmDialogModel('Confirm Action', message);
  //   const dialogRef = this.dialog.open(DeleteDocumentComponent, {
  //     maxWidth: '400px',
  //     height: '120px',
  //     data: dialogData
  //   });

  //   dialogRef.afterClosed().subscribe(dialogResult => {
  //     this.result = dialogResult;
  //     if (this.result) {
  //       this.dxService.UpdateDxEncIcdInfo(element.icdCode).subscribe(
  //         results => {
  //           this.result = results;
  //           this.loadDxFormIcddata();
  //           this.toastr.success(this.result);
  //         }
  //       );

  //     } else {
  //       this.result = dialogResult;
  //     }
  //   });

  // }
  DxClear() { }
  DxIcdSubmit() {

    if (this.icd != null) {
      var elemt1 = this.dxComponent.filter((attr: IDXDetails) => attr.icdCode == this.icd);
      this.selecteddxComponentData = {
        dxId: elemt1[0].dxId,
        patientId: elemt1[0].patientId,
        EncounterId: elemt1[0].EncounterId,
        icdCode: elemt1[0].icdCode,
        icdCodeDescription: this.ORDXForm.value.IcdCodeDesc,
        notes: this.ORDXForm.value.notes,
        isActive: elemt1[0].isActive,
        priority: elemt1[0].priority,
        createdBy: elemt1[0].createdBy,
        createdOn: elemt1[0].createdOn,
        modifiedBy: elemt1[0].modifiedBy,
        modifiedOn: elemt1[0].modifiedOn,
        background: '',
        isPast: null,
        categoryId: elemt1[0].categoryId,
        status: '',
        startDate: '',
        endDate: '',
        type: (elemt1[0].type != '' && elemt1[0].type) ? elemt1[0].type : ''
      }
    }

    if (this.selecteddxComponentData != null) {

      const removeindex1 = this.dxComponent.findIndex(x => x.icdCode === this.selecteddxComponentData.icdCode);
      if (removeindex1 != -1)
        this.dxComponent.splice(removeindex1, 1);

      this.dxComponent.push(this.selecteddxComponentData);
    }
    this.selecteddxComponentData = null
    this.dataSource.data = this.dxComponent;

  }


  DxIcdClear() {
    this.ORDXForm.patchValue({
      IcdCodeDesc: '',
      notes: '',
    });
    this.icd = '';
  }

  // OpenPopUp() {
  //   const dialogRef = this.dialog.open(DxCategoryComponent, {
  //     width: '900px',
  //     data: { headerText: "Please enter a value" }
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     this.loadDxFormIcddata();
  //     if (result && result != undefined)
  //   });

  // }

  // oncellclick(element) {
  //   this.selectedRowIndex = element.categoryIcdId;

  // }
  selectedRowIndex = "-1";
  oncellclick(element: IDXDetails) {
    this.selectedRowIndex = element.icdCode;
  }
  oncategoryclick(element) {

    if (!this.VisitNoteDx) {
      // if (element.categoryId == 2) {
      //   this.Iscurrenticdclicked = false;
      // }
      // else {
      this.Iscurrenticdclicked = true;
      // }
    }
    else {
      this.Iscurrenticdclicked = false;
    }
    this.oncategoryIndex = element.categoryId;
  }

  encounterData: CopyEncounterData;
  getPastEncounters() {
    //  this.openPastEncountersDialog();
  }
  // openPastEncountersDialog(): void {
  //   const dialogRef = this.dialog.open(CopyFromPreviousNotesComponent,
  //      {
  //     width: '900px',
  //   }
  //   );
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result != undefined && result.encounterId != undefined && result.selectedTypes != undefined)
  //       this.callConfirmation(result.encounterId, result.selectedTypes);

  //   });
  // }

  callConfirmation(encounterId: string, selectedTypes: string) {
    const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      height: '175px',
      data: { headerText: 'This will over write the existing(selected categories) notes. Do you want to proceed ?' }
    });

    dialogRef2.afterClosed().subscribe(result1 => {
      if (result1 && result1 != undefined) {
        {
          this.encounterData = new CopyEncounterData()
          this.encounterData.oldEncounterId = encounterId;
          this.encounterData.newEncounterId = CommonComponents.encounterId;
          this.encounterData.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
          this.encounterData.isActive = true;
          if (selectedTypes != undefined) {
            if (selectedTypes.indexOf("ROS") >= 0)
              this.encounterData.rosFlag = 'ROS';
            if (selectedTypes.indexOf("PE") >= 0)
              this.encounterData.peFlag = 'PE';
            if (selectedTypes.indexOf("HPI") >= 0)
              this.encounterData.hpiFlag = 'HPI';
            if (selectedTypes.indexOf("DX") >= 0)
              this.encounterData.dxFlag = 'DX';
            if (selectedTypes.indexOf("PROCEDURES") >= 0)
              this.encounterData.procedureFlag = 'PROCEDURES';

            if (selectedTypes.indexOf("ORDERS") >= 0)
              this.encounterData.ordersFlag = 'ORDERS';
            if (selectedTypes.indexOf("DISCUSSIONS") >= 0)
              this.encounterData.discussionFlag = 'DISCUSSIONS';
            if (selectedTypes.indexOf("ALL") >= 0) {
              // this.encounterData.allFlag  ='ALL';
              this.encounterData.rosFlag = 'ROS';
              this.encounterData.peFlag = 'PE';
              this.encounterData.hpiFlag = 'HPI';
              this.encounterData.dxFlag = 'DX';
              this.encounterData.procedureFlag = 'PROCEDURES';
              this.encounterData.ordersFlag = 'ORDERS';
              this.encounterData.discussionFlag = 'DISCUSSIONS';
            }

          }
          this.progressService.copyFromPastEncounter(this.encounterData).subscribe(result => {
            this.toastr.success(result);
            if (CommonComponents.encounterId && CommonComponents.patientId) {
              this.getDXInfo(CommonComponents.encounterId, CommonComponents.patientId);
              //  this.getAllProblemsInfoById(CommonComponents.encounterId, CommonComponents.patientId);

            }
          }
          );

        }

      }
    });

  }

  getVisitIsSignedoff() {
    if (this.encounterId != undefined) {
      this.sharedservice.getIsSignedoff(this.encounterId, 1).subscribe(data => {
        this.signoffEnc = data;
        if (data != undefined) {
          if (this.signoffEnc.isSignOff == true && this.signoffEnc.lockedby == null) {
            //  alert(this.signoffEnc.isSignOff);
            //this.ORDXForm.disable();
            this.disabledSaveSignoffButton = true;
            this.SignOffClicked = true;
          }
          else if (this.signoffEnc.isSignOff == true && this.signoffEnc.lockedby == sessionStorage.getItem("userId")) {
            this.ORDXForm.enable();
            //  this.checkLock();
          }
          else if (this.signoffEnc.isSignOff == true && this.signoffEnc.lockedby != sessionStorage.getItem("userId")) {
            this.ORDXForm.disable();
            this.disabledSaveSignoffButton = true;
            this.SignOffClicked = true;
          }
          else {
            this.ORDXForm.enable();
            this.checkLock();
          }
        }
      });
    }
  }

  // tabChanged() {
  //   // this.DxSubmit();

  //   if(this.callSave)
  //   {
  //    this.DxSubmit();
  //   }
  // }

  tabChanged(tablabelname: string) {

    this.changedTabLabel = tablabelname;
    if (this.callSave) {
      // const message = `You have unsaved changes. Are you sure you  want to save the Details ?`;
      // const dialogData = new ConfirmDialogModel('Confirm Action', message);
      // const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      //   maxWidth: '400px',
      //   height: '145px',
      //   data: dialogData
      // });

      // dialogRef.afterClosed().subscribe(dialogResult => {
      //   this.result = dialogResult;
      //   if (this.result) {
      this.isTabchange = true;
      this.DxSubmit();
      //   } else {
      //     this.result = dialogResult;
      //     this.router.navigateByUrl('/' + this.changedTabLabel.replace(" ", ""));
      //     this.spinner.hide();
      //   }
      // });
    }
    else {
      this.router.navigateByUrl('/' + this.changedTabLabel.replace(" ", ""));
      this.spinner.hide();
    }
  }

  checkLock() {
    this.lockService.getLockUsers(encodeURIComponent(sessionStorage.getItem("userId")), Defaults.lock_visitnote_dx, sessionStorage.getItem("FacilityId"), sessionStorage.getItem("encounterid")).subscribe(
      results => {
        this.lockedUser = results;
        if (this.lockedUser != null && this.lockedUser != undefined) {
          this.lockMessage = this.lockedUser.userName + " is working on this " + this.lockedUser.controlName + " form right now ";
          this.ORDXForm.disable();
          this.disabledSaveSignoffButton = true;
          this.SignOffClicked = true;
        }
      });
  }

  deleteLockUser() {
    this.lockService.deleteLockUser(encodeURIComponent(sessionStorage.getItem("userId")), CommonComponents.encounterId, Defaults.lock_visitnote_dx).subscribe(data => {
    })
  }

  public ngOnDestroy() {

    if (this.changedTabLabel == '') {
      // if (this.callSave) {

      //   const message = `You have unsaved changes. Are you sure you  want to save the Details ?`;
      //   const dialogData = new ConfirmDialogModel('Confirm Action', message);
      //   const dialogRef = this.dialog.open( {
      //     maxWidth: '400px',
      //     height: '145px',
      //     data: dialogData
      //   });

      //   dialogRef.afterClosed().subscribe(dialogResult => {
      //     this.result = dialogResult;
      //     if (this.result) {
      //       this.DxSubmit();
      //     }
      //   });
      // }
    }
  }




}

